import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./RSVPGuest.module.css";
import { BsFillFilterSquareFill } from "react-icons/bs";
import { List, Skeleton } from "antd";
import { FaCircleCheck } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";

import {
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import { EventPlanningMiddleware } from "../../../../../Store/Middlewares/EventPlanningMiddleware";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";

const RSVPGuest = () => {
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const GuestList = useSelector(
    (state) => state.EventPlanningReducer.GuestList
  );
  const [guestList, setGuestList] = useState([]);
  const [loading, setloading] = useState(true);
  const searchRef = useRef();
  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onAddGuest = (item) => {
    let arr = [...guestList];
    let findItem = arr.find((e) => e?.id == item?.id);

    if (!findItem) {
      arr.push(item);
      setGuestList(arr);
    } else {
      arr.pop(item);
      setGuestList(arr);
    }
  };
  console.table(GuestList?.guests)

  useEffect(() => {
    dispatch(
      EventPlanningMiddleware.getGuests({
        id: EventDetails?.id,
        status: "pending",
      })
    ).then(() => {
      setloading(false);
    });
  }, []);
  const onSearch = (name) => {
    clearTimeout(searchRef.current);
    searchRef.current = setTimeout(() => {
      setloading(true);
      dispatch(
        EventPlanningMiddleware.getGuests({
          id: EventDetails?.id,
          name,
          status: "pending",
        })
      ).then(() => {
        setloading(false);
      });
    }, 500);
  };

  const sendRsvp = () => {
    if (!guestList?.length > 0) {
      dispatch(
        showAlert({
          title: "sendRsvps",
          message: "Select the guests you want to send RSVP",
          type: "Error",
        })
      );
    } else {
      dispatch(
        EventPlanningMiddleware.sendRsvp({
          event_id: EventDetails?.id,
          users: guestList,
        })
      ).then((data) => navigate(-1));
    }
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.searchDiv}>
        <div className={styles.search}>
          <SearchInput
            placeholder={"Search"}
            onChange={(e) => onSearch(e.target.value)}
            // rightIcon={
            //   <BsFillFilterSquareFill size={25} className={styles.filterIcon} />
            // }
          />
        </div>
        <div className={styles.AG_btnDiv}>
          <SubmitButton
            title="Add Guest"
            onClick={() => {
              navigate("/events/guestDetails", {
                state: { headrTitle: "Guest" },
              });
            }}
            btnClass={styles.addGuestBtn}
          />
        </div>
      </div>
      <Skeleton loading={loading}>
        <List
          dataSource={GuestList?.guests?.length > 0 ? GuestList?.guests : []}
          className={styles.list}
          renderItem={(item, index) => {
            let findItem = guestList.find((e) => e?.id == item?.id);
            return (
              <div className={styles.listItem} onClick={() => onAddGuest(item)}>
                <TextComponent text={item?.name} textClass={styles.guestName} />
                <FaCircleCheck
                  className={
                    findItem ? styles.selectedItem : styles.unselectedItem
                  }
                />
              </div>
            );
          }}
        />
      </Skeleton>
      <div className={styles.btnDiv}>
        <SubmitButton
          title="Send RSVP"
          btnClass={styles.btn}
          onClick={sendRsvp}
        />
      </div>
    </div>
  );
};

export default RSVPGuest;
